import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { FormattedDate } from 'react-intl';

import { ListItem } from 'material-ui/List';

import Avatar from 'material-ui/Avatar';
import ContextIconMenu from '../Common/ContextIconMenu';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SettingsIcon from 'material-ui/svg-icons/action/settings';

import EventIcon from 'material-ui/svg-icons/action/event';

import { avatar as avatarColours } from '../../constants/ColourConstants';
import { DateStyles } from '../../constants/CentricConstants';
import EventActions from '../../actions/EventActionCreator';

import ROLES from '../../constants/Roles';


const style = {
    listItem: {
        padding: '2px',
    },

};

class EventListItem extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            links: {
                back: '/dashboard/events'
            }
        };

        this._onDelete = this._onDelete.bind(this);
        this._onDeletePeriodicAllInstances = this._onDeletePeriodicAllInstances.bind(this);
        this._onDeletePeriodicInstance = this._onDeletePeriodicInstance.bind(this);
        this._onDeletePeriodicWithFollowingInstances = this._onDeletePeriodicWithFollowingInstances.bind(this);
    }

    getActions(row, infoLink = `/dashboard/event/${row.id}`) {
        if (!row.id) { return null; }

        const editLink = `${infoLink}/edit`;
        const settingsLink = `${infoLink}/settings`;

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon/>
            },
            { type: 'divider' },
            {
                link: settingsLink,
                label: 'Settings',
                icon: <SettingsIcon/>,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            { type: 'divider' },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon/>,
                condition: {
                    show: !!row.canEdit
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete periodic event',
                menuTitle: 'Delete this instance',
                deleteAction: this._onDeletePeriodicInstance,
                message: (<span>All other events in the series will be retained. Are you sure to delete this event  "{row.name}" ?</span>),
                condition: {
                    show: !!row.periodic,
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete periodic event',
                menuTitle: 'Delete all the following',
                deleteAction: this._onDeletePeriodicWithFollowingInstances,
                message: (<span>This and all the following events will be deleted. Are you sure to delete this event  "{row.name}" ?</span>),
                condition: {
                    show: !!row.periodic,
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete periodic event',
                menuTitle: 'Delete all events series',
                deleteAction: this._onDeletePeriodicAllInstances,
                message: (<span>All events in the series will be deleted. Are you sure to delete this event  "{row.name}" ?</span>),
                condition: {
                    show: !!row.periodic,
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete event',
                deleteAction: this._onDelete,
                message: (<span>Are you sure to delete this event  "{row.name}" ?</span>),
                condition: {
                    show: (!row.periodic && row.sysStatus > 4 && this.context.auth.canEdit(row.access)),
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    }

    getPrimaryLink({id}) {
        return `/dashboard/event/${id}`;
    }

    getAvatarStyle() {
        switch(this.props.data.type) {
            case 'event':
                return avatarColours.default;
            case 'course':
                return avatarColours.default;
            case 'template':
                return avatarColours.default;
            default:
                return avatarColours.default;
        }
    }

    getAvatarIcon() {
        return <EventIcon/>;
    }

    render() {
        const infoLink = this.getPrimaryLink(this.props.data);
        const actions = this.getActions(this.props.data);

        let listItemProps = {
            key: this.props.data.id,
            style: style.listItem
        };

        listItemProps.primaryText = (
            <Link to={infoLink} className="primaryText">
                {this.props.data.name}
            </Link>
        );

        let rightIcon = null;
        if (!!actions && actions.length > 0) {
            rightIcon = (<ContextIconMenu actions={actions} data={this.props.data} />);
        }

        let statusLine = this.props.data.venue;
        if (!!this.props.data.location) {
            statusLine += `, ${this.props.data.location}`;
        }

        let flags = [];
        if (this.props.data.visibility === 'private') {
            flags.push(<span key="a" className="flag-text">private</span>);
        }


        listItemProps.secondaryText = (
            <Link to={infoLink} className="secondaryText">
                {flags}
                <FormattedDate  value={this.props.data.timeStart} {...DateStyles.fullDateTime} />
                <br />
                <em>{statusLine}</em>
            </Link>
        );

        listItemProps.secondaryTextLines = 2;

        return (
            <ListItem {...listItemProps}
                leftAvatar={
                    <Link to={infoLink}>
                        <Avatar icon={this.getAvatarIcon()} style={this.getAvatarStyle()} />
                    </Link>
                }
                rightIcon={rightIcon}
            />
        )
    }

    _onDelete(eventId) {
         if (eventId === this.props.data.id) {
            EventActions.delete(eventId);
            // browserHistory.replace(this.state.links.back);
        }
    }

    _onDeletePeriodicInstance(eventId) {
        if (eventId === this.props.data.id) {
            EventActions.deletePeriodicInstance(eventId);
            // browserHistory.replace(this.state.links.back);
        }
    }

    _onDeletePeriodicWithFollowingInstances(eventId) {
        if (eventId === this.props.data.id) {
            EventActions.deletePeriodicWithFollowingInstances(eventId);
            // browserHistory.replace(this.state.links.back);
        }
    }
    _onDeletePeriodicAllInstances(eventId) {
        if (eventId === this.props.data.id) {
            EventActions.deletePeriodicAllInstances(eventId);
            // browserHistory.replace(this.state.links.back);
        }
    }
}

EventListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};


export default EventListItem;
